import {Global} from '../models/global';
import {Sprint} from '../models/sprint';

declare var $: any;

export class SprintApi {
    public async grid(offset: number, numberOfWeeks: number): Promise<Global> {
        const result = await fetch(`/api/sprints/grid?offset=${offset}&number_of_weeks=${numberOfWeeks}`, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            }),
        });

        return await result.json();
    }

    public async move(sprintId: number, employeeId: number, date: string): Promise<Sprint> {
        const response = await fetch(`/api/sprints/${sprintId}/move`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            }),
            body: JSON.stringify({
                date: date,
                employee_id: employeeId,
            }),
        });
        return await response.json();
    }

    public async destroy(sprintId: number): Promise<void> {
        await fetch(`/api/sprints/${sprintId}/destroy`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            }),
        });
    }

    async update(sprint: Sprint): Promise<Sprint> {
        const response = await fetch(`/api/sprints/${sprint.id}`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            }),
            body: JSON.stringify({
                hours: sprint.hours,
                is_extra: sprint.is_extra,
            }),
        });
        return await response.json();
    }

    public async create(
        employeeId: number,
        estimateId: number,
        hours: number,
        isExtra: boolean,
        from: string,
        till: string,
    ): Promise<Sprint[]> {
        const result = await fetch(`/api/sprints`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            }),
            body: JSON.stringify({
                employee_id: employeeId,
                estimate_id: estimateId,
                hours: hours,
                is_extra: isExtra,
                from_date: from,
                till_date: till,
            }),
        });

        return await result.json();
    }

    async destroyMany(sprintIds: number[]) {
        await fetch(`/api/sprints/destroy`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            }),
            body: JSON.stringify({
                ids: sprintIds.join(','),
            }),
        });
    }
}
